export const codeStyle = {
  borderRadius: ".2rem",
  padding: "0 .1rem",
  fontFamily: "'Consolas', monospace"
};
